import { ConfigState, EmpathyXConfig, FacetConfig, FacetsGroupConfig } from '../../../models';
import { Dictionary } from '../../../utils';
import { CONFIG_GETTERS_KEYS } from '../../config/config.const';
import { ConfigGetter } from '../config.interfaces';

export type GetFacetConfigByName = (facetName: string, groupName?: string) => FacetConfig;

export class FacetGetter implements ConfigGetter {
  getters = {
    /*
     This getter returns a function to retrieve the configuration of a single facet, either outside of a group, or inside a group.
     */
    [CONFIG_GETTERS_KEYS.facet]: (configState: ConfigState, getters: any): GetFacetConfigByName => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      const defaultFacetConfig = config.facets.default.facet;
      const facetsConfig: Dictionary<FacetConfig> = getters[CONFIG_GETTERS_KEYS.facets];
      const facetsGroupsConfig: Dictionary<FacetsGroupConfig> = getters[CONFIG_GETTERS_KEYS.facetsGroups];
      return (facetName: string, groupName?: string) => {
        if (groupName) {
          const groupConfig = facetsGroupsConfig[groupName];
          // Safe cast. This comes from the Getters.config.facetsGroups, which merges the facet configuration with the default ones
          const facetConfigForGroup = groupConfig?.facets?.[facetName] as FacetConfig | undefined;
          if (facetConfigForGroup) {
            return facetConfigForGroup;
          }
        }
        return facetsConfig[facetName] ?? defaultFacetConfig;
      };
    }
  };
}
